<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="公司ID,关联{sys_dept.id}" prop="companyId">
                <a-input
                  v-model:value="queryParam.companyId"
                  placeholder="请输入公司ID,关联{sys_dept.id}"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item
                label="项目ID,关联{zb_project_info.id}"
                prop="projectId"
              >
                <a-input
                  v-model:value="queryParam.projectId"
                  placeholder="请输入项目ID,关联{zb_project_info.id}"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="空间ID,关联{zb_space.id}" prop="spaceId">
                  <a-input
                    v-model:value="queryParam.spaceId"
                    placeholder="请输入空间ID,关联{zb_space.id}"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="空间名称" prop="spaceName">
                  <a-input
                    v-model:value="queryParam.spaceName"
                    placeholder="请输入空间名称"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="员工ID,关联{sys_user.id}" prop="employeeId">
                  <a-input
                    v-model:value="queryParam.employeeId"
                    placeholder="请输入员工ID,关联{sys_user.id}"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="员工名" prop="employeeName">
                  <a-input
                    v-model:value="queryParam.employeeName"
                    placeholder="请输入员工名"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="进入时间" prop="entryTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model:value="queryParam.entryTime"
                    format="YYYY-MM-DD HH:mm:ss"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="离开时间" prop="departureTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model:value="queryParam.departureTime"
                    format="YYYY-MM-DD HH:mm:ss"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="停留时长" prop="stayDuration">
                  <a-input
                    v-model:value="queryParam.stayDuration"
                    placeholder="请输入停留时长"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item
                  label="空间性质(固定打卡点、单人任务、多人任务、机动任务)"
                  prop="spatialProperties"
                >
                  <a-input
                    v-model:value="queryParam.spatialProperties"
                    placeholder="请输入空间性质(固定打卡点、单人任务、多人任务、机动任务)"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="排序" prop="sort">
                  <a-input
                    v-model:value="queryParam.sort"
                    placeholder="请输入排序"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="handleQuery"
                  ><a-icon type="search" />查询</a-button
                >
                <a-button style="margin-left: 8px" @click="resetQuery"
                  >重置</a-button
                >
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button
          type="primary"
          @click="$refs.createForm.handleAdd()"
          v-hasPermi="['system:spaceStayRecord:add']"
        >
          <a-icon type="plus" />新增
        </a-button>
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['system:spaceStayRecord:edit']"
        >
          <a-icon type="edit" />修改
        </a-button>
        <a-button
          type="danger"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['system:spaceStayRecord:remove']"
        >
          <a-icon type="delete" />删除
        </a-button>
        <a-button
          type="primary"
          @click="handleExport"
          v-hasPermi="['system:spaceStayRecord:export']"
        >
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          v-model:table-size="tableSize"
          v-model:value="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" @close="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template v-slot:entryTime="text, record">
          <span>
            {{ parseTime(record.entryTime) }}
          </span>
        </template>
        <template v-slot:departureTime="text, record">
          <span>
            {{ parseTime(record.departureTime) }}
          </span>
        </template>
        <template v-slot:createTime="text, record">
          <span>
            {{ parseTime(record.createTime) }}
          </span>
        </template>
        <template v-slot:operation="text, record">
          <span>
            <a-divider
              type="vertical"
              v-hasPermi="['system:spaceStayRecord:edit']"
            />
            <a
              @click="$refs.createForm.handleUpdate(record, undefined)"
              v-hasPermi="['system:spaceStayRecord:edit']"
            >
              <a-icon type="edit" />修改
            </a>
            <a-divider
              type="vertical"
              v-hasPermi="['system:spaceStayRecord:remove']"
            />
            <a
              @click="handleDelete(record)"
              v-hasPermi="['system:spaceStayRecord:remove']"
            >
              <a-icon type="delete" />删除
            </a>
          </span>
        </template>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageSpaceStayRecord,
  listSpaceStayRecord,
  delSpaceStayRecord,
} from '@/api/system/spaceStayRecord'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'SpaceStayRecord',
  components: {
    CreateForm,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        companyId: null,
        projectId: null,
        spaceId: null,
        spaceName: null,
        employeeId: null,
        employeeName: null,
        stayDate: null,
        entryTime: null,
        departureTime: null,
        stayDuration: null,
        spatialProperties: null,
        status: null,
        sort: null,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: 'id',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '公司ID,关联{sys_dept.id}',
          dataIndex: 'companyId',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '项目ID,关联{zb_project_info.id}',
          dataIndex: 'projectId',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '空间ID,关联{zb_space.id}',
          dataIndex: 'spaceId',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '空间名称',
          dataIndex: 'spaceName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '员工ID,关联{sys_user.id}',
          dataIndex: 'employeeId',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '员工名',
          dataIndex: 'employeeName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '日期',
          dataIndex: 'stayDate',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '进入时间',
          dataIndex: 'entryTime',
          scopedSlots: { customRender: 'entryTime' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '离开时间',
          dataIndex: 'departureTime',
          scopedSlots: { customRender: 'departureTime' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '停留时长',
          dataIndex: 'stayDuration',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '空间性质(固定打卡点、单人任务、多人任务、机动任务)',
          dataIndex: 'spatialProperties',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '状态 1显示 0-不显示',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '排序',
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询空间停留记录列表 */
    getList() {
      this.loading = true
      pageSpaceStayRecord(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        companyId: undefined,
        projectId: undefined,
        spaceId: undefined,
        spaceName: undefined,
        employeeId: undefined,
        employeeName: undefined,
        stayDate: undefined,
        entryTime: undefined,
        departureTime: undefined,
        stayDuration: undefined,
        spatialProperties: undefined,
        status: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delSpaceStayRecord(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/space-stay-record/export',
            {
              ...that.queryParam,
            },
            `空间停留记录_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
